/**
 * Поддержка старых браузеров: iOS Safari 15.0+ / Safari 15.0+
 *
 * crypto.randomUUID() доступен только с Safari 15.4 и требует secure context (HTTPS).
 * Полифилл через crypto.getRandomValues (Safari 11+) — запускается ДО загрузки приложения.
 *
 * Минимальные поддерживаемые версии: см. browserslist в package.json
 * Задача: CLOUD-11703
 */
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  const RANDOM_BYTE_COUNT = 1;
  const UUID_VARIANT_MASK = 15;
  const UUID_VERSION_DIVISOR = 4;
  const HEX_RADIX = 16;

  crypto.randomUUID = () =>
    '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c => {
      /* eslint-disable no-bitwise -- RFC 4122 UUID v4 polyfill (bit nibble substitution) */
      return (
        +c ^
        (crypto.getRandomValues(new Uint8Array(RANDOM_BYTE_COUNT))[0] &
          (UUID_VARIANT_MASK >> (+c / UUID_VERSION_DIVISOR)))
      ).toString(HEX_RADIX);
      /* eslint-enable no-bitwise */
    });
}

import('./bootstrap');
